import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { APP_BASE_HREF } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';

import { AppConstants } from '@unpispas/upp-defs';
import { langsPath } from '@unpispas/upp-base';
import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { FeatureGuestModule } from '@unpispas/feature/guest';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule,
    UppBaseModule,
    UppWdgtModule,
    FeatureGuestModule,
    IonicModule.forRoot(),
    ServiceWorkerModule.register('firebase-messaging-sw.js', {
      scope: AppConstants.appRoute,
      enabled: !document.URL.startsWith('http://localhost/'),
      registrationStrategy: 'registerWhenStable:2000',
    }),
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: document.querySelector('base')?.getAttribute('href') || '/' },
    { provide: langsPath, useFactory: (baseHref: string) => `${baseHref}lang`, deps: [APP_BASE_HREF] },
    Geolocation,
    AndroidPermissions,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
